import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  grid-row-start: 2;
  grid-row-end: 3;
  backgroundColor: "#D3D3D3";
`;

const MainContentWrapper = (props) => {
  return <Wrapper {...props}>{props.children}</Wrapper>;
};

export default MainContentWrapper;
